import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { includes, uniqBy, capitalize } from "lodash";
import moment from 'moment';

import $ from 'jquery';

import { hasPermission, hasRoleOrMore } from '../../../lib/auth/permission';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Document, User } from '../../../types';
import { REMOTE_API_HOST } from '../../../lib/rpc';
import { DocumentTypes } from '../../../lib/content/statics';
import SendDocumentDialog from '../../components/molecules/SendDocumentDialog';
import DocumentDialog from '../../components/organisms/DocumentDialog';
import { shareDocument, updateDocument } from '../../../redux/documents';
import { loadArticlesData, loadDocuments } from "../../../redux/articles";
import SimpleConfirmDialog from '../../components/molecules/SimpleConfirmDialog';
import { updateUser, loadUsers, adminResetPassword } from '../../../redux/user';

interface Props {
  entry: User | null
  history: any
  updateUser: (userId: number, change: Partial<User>) => Promise<void>
  loadUsers: () => Promise<void>
  adminResetPassword: (userId: number) => Promise<void>
}
interface States {
  dialogBody: JSX.Element
  dialogTitle: string
  loading?: boolean
}

class UserDetailsPage extends Component<Props, States> {
  private action: string = '';

  constructor(props: Props) {
    super(props);
    this.state = {
      dialogBody: <></>,
      dialogTitle: '',
    };
  }

  resetPassword(e: Event) {
    e.preventDefault();
    this.setState({
      dialogTitle: 'Reset password',
      dialogBody: (<p>New password will be auto-generated and send to the e-Mail
        address.</p>),
    });
    ($('#dlg-confirm') as any).modal();
    this.action = 'reset';
  }

  unblockUser(e: Event) {
    e.preventDefault();
    this.setState({
      dialogTitle: 'Unblock',
      dialogBody: (<p>User will be unblocked and will be able to login.</p>),
    });
    ($('#dlg-confirm') as any).modal();
    this.action = 'unblock';
  }

  blockUser(e: Event) {
    e.preventDefault();
    this.setState({
      dialogTitle: 'Block',
      dialogBody: (<p>User will be blocked and can not login anymore. User can be unblocked by director.</p>),
    });
    ($('#dlg-confirm') as any).modal();
    this.action = 'block';
  }

  async doAction() {
    this.setState({
      loading: true,
    });

    try {
      if (this.action === 'block') {
        await this.props.updateUser(this.props.entry!.id, {blocked: true});
      } else if (this.action === 'unblock') {
        await this.props.updateUser(this.props.entry!.id, {blocked: false});
      } else if (this.action === 'reset') {
        await this.props.adminResetPassword(this.props.entry!.id);
        alert('A new invitation mail with a generated password will be send to the user.');
      }
      await this.props.loadUsers();
    } catch (err) {
      alert('Something went wrong. ' + JSON.stringify(err));
    }

    ($('#dlg-confirm') as any).modal('hide');
    this.setState({
      loading: false,
    });
  }

  render() {
    const {
      entry,
    } = this.props;
    const {
      dialogBody,
      dialogTitle,
      loading,
    } = this.state;

    return (
      <>
        <div className="container-fluid">
          <Link to={`/users`}>
            <small className="">&lt;&lt; back</small>
          </Link>
        </div>
        <div className="container mt-2">
          <h4>
            User
          </h4>

          {entry && (
            <>
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <th scope="row">Full name</th>
                    <td>
                      {entry.username}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">E-Mail</th>
                    <td>
                      {entry.email}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Role</th>
                    <td>
                      {capitalize(entry.role.name)}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Blocked</th>
                    <td>
                      {'' + entry.blocked}
                    </td>
                    </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>
                      <a
                        href="#"
                        onClick={(e: any) => this.resetPassword(e)}>
                        <i className="material-icons" style={{verticalAlign: 'middle', marginRight: 4}}>settings_backup_restore</i>
                        Reset password
                      </a>
                      <br/>
                      {entry.blocked && (
                          <a
                            href="#"
                            onClick={(e: any) => this.unblockUser(e)}>
                            <i className="material-icons" style={{verticalAlign: 'middle', marginRight: 4}}>verified_user</i>
                            Unblock user
                          </a>
                      ) || (
                        <a
                          href="#"
                          onClick={(e: any) => this.blockUser(e)}>
                          <i className="material-icons" style={{verticalAlign: 'middle', marginRight: 4}}>block</i>
                          Block user
                        </a>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>

              <SimpleConfirmDialog
                id="dlg-confirm"
                body={dialogBody}
                onSubmit={() => this.doAction()}
                title={dialogTitle}
                loading={loading}
              />
            </>
          )}
        </div>
      </>
    )
  }
}

const mapStateToProps = ({user} : any, ownProps: any) => {
  return {
    entry: user.users.filter((d: User) => d.id === ownProps.match.params.id)[0],
  };
}

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      updateUser, loadUsers, adminResetPassword
    },
    dispatch
  )

const pageRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDetailsPage as any)

export default withRouter(pageRedux);
